var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInterruptedByUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 24 24",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "svg1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 17,22 C 0,0 0,0 17,22 Z M 18,3 H 14.82 C 14.4,1.84 13.3,1 12,1 10.7,1 9.6,1.84 9.18,3 H 6 C 4.9,3 4,3.9 4,5 v 15 c 0,1.1 0.9,2 2,2 h 6.11 C 11.52,21.43 11.04,20.75 10.69,20 H 6 V 5 h 2 v 3 h 8 V 5 h 2 v 5.08 c 0.71,0.1 1.38,0.31 2,0.6 V 5 C 20,3.9 19.1,3 18,3 Z m -6,2 c -0.55,0 -1,-0.45 -1,-1 0,-0.55 0.45,-1 1,-1 0.55,0 1,0.45 1,1 0,0.55 -0.45,1 -1,1 z",
    id: "path1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2",
    transform: "translate(0.30788126,-0.62348533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 12.879515,22.702793 2.601972,-7.05e-4 -0.002,-8.335439 -2.601972,7.05e-4 z m 5.201983,-8.336849 0.002,8.335439 2.601972,-7.04e-4 -0.002,-8.33544 z",
    id: "path2",
    style: {
      strokeWidth: 0.622331
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterruptedByUserIcon);
export default __webpack_public_path__ + "static/media/InterruptedByUserIcon.435d4cdbf49a8d1a564e98d558a493c7.svg";
export { ForwardRef as ReactComponent };